module.exports = __webpack_public_path__ + "static/media/onboarding-confirmation.a49caa44.svg";